import { render, staticRenderFns } from "./popup-create.vue?vue&type=template&id=6b81eca7&scoped=true"
import script from "./popup-create.vue?vue&type=script&lang=js"
export * from "./popup-create.vue?vue&type=script&lang=js"
import style0 from "./popup-create.vue?vue&type=style&index=0&id=6b81eca7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81eca7",
  null
  
)

export default component.exports